"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
const Warning_1 = __importDefault(require("@material-ui/icons/Warning"));
const Check_1 = __importDefault(require("@material-ui/icons/Check"));
const icons_1 = require("../../icons");
const CommonWeb_1 = require("./CommonWeb");
const styles_1 = require("@material-ui/core/styles");
const TGRadioFieldWeb_1 = __importDefault(require("./TGRadioFieldWeb"));
const TGTextFieldRootWeb_1 = __importDefault(require("./TGTextFieldRootWeb"));
const react_qr_reader_1 = __importDefault(require("react-qr-reader"));
const FieldHeader_1 = __importDefault(require("./FieldHeader"));
const DialogWrapperWeb_1 = __importDefault(require("../Common/DialogWrapperWeb"));
const TGLabelWrapperWeb_1 = __importDefault(require("./TGLabelWrapperWeb"));
const clsx_1 = __importDefault(require("clsx"));
const theme_1 = require("../../styles/theme");
const utils_1 = require("../../utils");
var BarcodeEntryType;
(function (BarcodeEntryType) {
    BarcodeEntryType["DEVICE_CAMERA"] = "0";
    BarcodeEntryType["HANDHELD_SCANNER"] = "1";
    BarcodeEntryType["MANNUAL_ENTRY"] = "2";
})(BarcodeEntryType || (BarcodeEntryType = {}));
var CameraOptions;
(function (CameraOptions) {
    CameraOptions["SYSTEM_CAMERA"] = "0";
})(CameraOptions || (CameraOptions = {}));
const useBarcodeValidation = (validator) => {
    const [value, setValue] = react_1.useState('');
    const [error, setError] = react_1.useState('');
    const updateValue = async (item) => {
        setValue(item);
        const { errors } = await Promise.resolve(validator ? validator(item, {}) : Promise.resolve({ errors: [], warnings: [] }));
        if (errors.length) {
            setError(errors[0]);
        }
        else {
            setError('');
        }
    };
    return { value, updateValue, error, setError };
};
//to be render at 'scan with device camera' radio option
const ScanWithCamera = props => {
    const { setScanOption, validator, setValidBarCode, camera, setCamera } = props;
    const [cameraError, setCameraError] = react_1.useState(null);
    const { value: scanResult, updateValue: setScanResult, error, setError } = useBarcodeValidation(validator);
    const [isScanning, setIsScanning] = react_1.useState(true);
    const [screenShot, setScreenShot] = react_1.useState('');
    const cameraRef = react_1.useRef(null);
    react_1.useEffect(() => {
        if (scanResult && !error) {
            setValidBarCode(scanResult);
        }
        else {
            setValidBarCode('');
        }
    }, [scanResult, error, setValidBarCode]);
    const reScan = () => {
        setCameraError(null);
        setScanResult('');
        setIsScanning(true);
        setError('');
    };
    const onScan = (result) => {
        setIsScanning(true);
        if (result) {
            if (cameraRef.current) {
                // @ts-ignore
                setScreenShot(cameraRef.current.els.canvas.toDataURL());
            }
            setScanResult(result);
            setIsScanning(false);
        }
    };
    const scanWithCameraStyles = useScanWithCameraStyles();
    return (react_1.default.createElement(core_1.Box, { className: scanWithCameraStyles.container },
        react_1.default.createElement(TGRadioFieldWeb_1.default, { className: scanWithCameraStyles.cameraDropdown, value: camera, label: 'Select camera', options: [
                {
                    value: CameraOptions.SYSTEM_CAMERA,
                    label: 'System camera',
                },
            ], onChange: (evt) => {
                setCamera(evt.target.value);
            } }),
        cameraError ? (react_1.default.createElement(Alert_1.default, { icon: react_1.default.createElement(Warning_1.default, null), className: scanWithCameraStyles.warningMessage, severity: "warning" }, "No cameras are detected on this device. Please connect one, and make sure your browser has allowed this page to access the camera")) : (react_1.default.createElement(core_1.Box, { style: { height: 'fit-content', marginBottom: 67 } },
            react_1.default.createElement(core_1.Typography, { display: "inline", className: scanWithCameraStyles.hText }, "Hold your device\u2019s camera up to the barcode to scan"),
            react_1.default.createElement(core_1.Box, { className: scanWithCameraStyles.qrCode },
                !error && scanResult && (react_1.default.createElement(core_1.Fab, { size: "large", className: scanWithCameraStyles.checkIconBtn },
                    react_1.default.createElement(Check_1.default, null))),
                error && scanResult && react_1.default.createElement(icons_1.ErrorIcon, { className: scanWithCameraStyles.errorIconBtn }),
                react_1.default.createElement(core_1.Box, { className: `${scanWithCameraStyles.borderBox} ${isScanning && scanWithCameraStyles.borderBoxScanning} ${scanResult && scanWithCameraStyles.borderBoxScanned}` }),
                react_1.default.createElement("div", { className: scanWithCameraStyles.cameraWrapper },
                    scanResult && !isScanning && (react_1.default.createElement("img", { src: screenShot, className: scanWithCameraStyles.previewStyles, alt: 'scan result preview' })),
                    isScanning && (react_1.default.createElement(react_qr_reader_1.default, { ref: cameraRef, className: scanWithCameraStyles.cameraStyles, delay: 300, onError: (err) => {
                            setCameraError(err);
                        }, onScan: onScan })))),
            isScanning && !scanResult && (react_1.default.createElement(core_1.Typography, { className: `${scanWithCameraStyles.fontSizeSm} ${scanWithCameraStyles.fontBold}` }, "Scanning...")),
            scanResult && !error && (react_1.default.createElement(core_1.Typography, { className: `${scanWithCameraStyles.fontSizeSm} ${scanWithCameraStyles.fontBold}` }, "Scan complete")),
            scanResult && !error && (react_1.default.createElement(core_1.Typography, { className: `${scanWithCameraStyles.fontSizeLg} ${scanWithCameraStyles.textGreen} ${scanWithCameraStyles.fontSlightlyBold}` }, scanResult)),
            error && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Typography, { className: `${scanWithCameraStyles.fontSizeSm} ${scanWithCameraStyles.fontBold}` }, "The scanned code is invalid."),
                react_1.default.createElement(core_1.Typography, { className: `${scanWithCameraStyles.fontSizeLg} ${scanWithCameraStyles.errorText} ${scanWithCameraStyles.fontSlightlyBold}` }, scanResult),
                react_1.default.createElement(core_1.Typography, { className: `${scanWithCameraStyles.fontSizeNormal} ${scanWithCameraStyles.errorText}` }, error))),
            react_1.default.createElement(core_1.Box, { mt: 2 },
                scanResult && (react_1.default.createElement(core_1.Button, { variant: "contained", onClick: reScan }, "Rescan")),
                scanResult && error && (react_1.default.createElement(core_1.Button, { className: `${scanWithCameraStyles.mlSm}`, variant: "contained", onClick: () => setScanOption(BarcodeEntryType.MANNUAL_ENTRY) }, "Edit Manually")))))));
};
const useScanWithCameraStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    cameraDropdown: {
        width: '250px',
        marginBottom: '20px',
    },
    container: {
        marginBottom: 20,
    },
    hText: {
        fontSize: 14,
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: 'normal',
        color: theme_1.colors.black0,
    },
    cameraStyles: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        borderRadius: 25,
        '& section': {
            position: 'unset !important',
            '& div': {
                display: 'none',
            },
            '& video': {
                borderRadius: 5,
            },
        },
    },
    warningMessage: {
        backgroundColor: theme_1.colors.backgroundLight,
        color: theme_1.colors.black,
        fontSize: 16,
        margin: '25px 0px',
        '& .MuiAlert-icon': {
            color: '#8c8c8c',
            '& .MuiSvgIcon-root': {
                fontSize: 45,
            },
        },
    },
    cameraWrapper: {
        width: '100%',
        height: '350px',
    },
    previewStyles: { width: '100%', height: '100%' },
    qrCode: {
        position: 'relative',
        marginTop: 12,
        marginBottom: 10,
    },
    borderBoxScanning: {
        boxShadow: '#56CCF2 0px 0px 0px 3px inset',
    },
    borderBoxScanned: {
        boxShadow: '#2b6679 0px 0px 0px 3px inset',
    },
    borderBox: {
        top: 0,
        left: 0,
        zIndex: 1,
        boxSizing: 'border-box',
        border: '40px solid transparent',
        position: 'absolute',
        width: '100%',
        height: '100%',
        borderRadius: 46,
    },
    checkIconBtn: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 99,
        height: 100,
        width: 100,
        backgroundColor: theme_1.colors.white,
        color: '#43A047',
        pointerEvents: 'none',
        '& .MuiSvgIcon-root': {
            fontSize: 90,
        },
    },
    errorIconBtn: {
        position: 'absolute',
        top: '40%',
        left: '45%',
        zIndex: 99,
        height: 100,
        width: 100,
        backgroundColor: theme_1.colors.white,
        color: '#43A047',
        pointerEvents: 'none',
        '& .MuiSvgIcon-root': {
            fontSize: 90,
        },
    },
    errorIcon: {
        color: theme_1.colors.white,
    },
    fontSizeSm: {
        fontSize: 14,
    },
    fontSizeNormal: {
        fontSize: 16,
    },
    fontSizeLg: {
        fontSize: 18,
    },
    fontSlightlyBold: {
        fontWeight: 500,
    },
    fontBold: {
        fontWeight: 400,
        color: theme_1.colors.black0,
    },
    textGreen: {
        color: '#50AD55',
    },
    errorText: {
        color: '#EB5757',
    },
    //margin
    mlSm: {
        // marginLeftSmall
        marginLeft: theme.spacing(1),
    },
}));
//to be render at 'scan with handheld scanner' radio option
const ScanWithHandheldCamera = props => {
    const { placeholder, validator, value, setValidBarCode } = props;
    const { value: barcode, updateValue: setBarCode, error: barcodeError } = useBarcodeValidation(validator);
    react_1.useEffect(() => {
        if (!barcodeError) {
            setValidBarCode(barcode);
        }
        else {
            setValidBarCode('');
        }
    }, [barcode, barcodeError, setValidBarCode]);
    return (react_1.default.createElement(core_1.Box, { mt: 2 },
        react_1.default.createElement(TGTextFieldRootWeb_1.default, { autoFocus: true, label: 'Barcode element label', placeholder: placeholder, defaultValue: value, value: barcode, error: !!barcodeError, helperText: barcodeError, onChange: evt => setBarCode(evt.target.value) })));
};
//to be render at 'enter manually' radion option
const EnterManually = props => {
    const { value, validator, setValidBarCode, placeholder, readOnly } = props;
    const { value: barcode, updateValue: setBarCode, error: barcodeError } = useBarcodeValidation(validator);
    const { value: repeatBarcode, updateValue: setRepeatBarcode, error: repeatBarcodeError } = useBarcodeValidation(validator);
    const [barcodeMatchError, setBarCodeMatchError] = react_1.useState('');
    react_1.useEffect(() => {
        const isBarcodesValid = !barcodeError && !repeatBarcodeError;
        if (repeatBarcode && barcode && isBarcodesValid) {
            if (barcode !== repeatBarcode) {
                setBarCodeMatchError('Uh oh…This entry doesnt match');
            }
            else {
                setBarCodeMatchError('');
                return setValidBarCode(barcode);
            }
        }
        return setValidBarCode(false);
    }, [barcode, repeatBarcode, barcodeError, repeatBarcodeError, setValidBarCode]);
    return (react_1.default.createElement(core_1.Box, { mt: 2 },
        react_1.default.createElement(TGTextFieldRootWeb_1.default, { label: 'Barcode element label', InputProps: {
                readOnly,
            }, placeholder: placeholder, defaultValue: value, value: barcode, error: !!barcodeError, helperText: barcodeError, onChange: evt => setBarCode(evt.target.value) }),
        react_1.default.createElement(core_1.Box, { mt: 2 },
            react_1.default.createElement(TGTextFieldRootWeb_1.default, { label: 'Re-enter barcode element label', InputProps: {
                    readOnly,
                }, placeholder: placeholder, defaultValue: value, value: repeatBarcode, error: !!repeatBarcodeError || !!barcodeMatchError, helperText: barcodeMatchError || repeatBarcodeError, onChange: evt => setRepeatBarcode(evt.target.value) }))));
};
const OptionSelector = ({ scanOption, setScanOption }) => {
    const scanWithCameraStyles = useScanWithCameraStyles();
    return (react_1.default.createElement(core_1.Box, { className: scanWithCameraStyles.container },
        react_1.default.createElement(TGRadioFieldWeb_1.default, { label: 'Barcode entry type', value: scanOption, options: [
                {
                    value: BarcodeEntryType.DEVICE_CAMERA,
                    label: 'Scan with device camera',
                },
                {
                    value: BarcodeEntryType.HANDHELD_SCANNER,
                    label: 'Scan with handheld scanner',
                },
                {
                    value: BarcodeEntryType.MANNUAL_ENTRY,
                    label: 'Enter manually',
                },
            ], onChange: (x) => setScanOption(x.target.value) })));
};
const TGBarCodeFields = props => {
    const { value, label, placeholder, onChange, readOnly, validator, toggleModal } = props;
    const [scanOption, setScanOption] = react_1.useState(BarcodeEntryType.DEVICE_CAMERA);
    const [barCode, setBarCode] = react_1.useState('');
    const [camera, setCamera] = react_1.useState(CameraOptions.SYSTEM_CAMERA);
    const classes = CommonWeb_1.useStyles();
    const onDonePress = () => {
        onChange(barCode);
        toggleModal && toggleModal();
    };
    const onCancelPress = () => {
        toggleModal && toggleModal();
    };
    const isCameraActive = camera === CameraOptions.SYSTEM_CAMERA;
    const barcodeStyles = usebarcodeStyles({ isCameraActive });
    return (react_1.default.createElement(core_1.FormControl, { className: barcodeStyles.root },
        react_1.default.createElement(FieldHeader_1.default, { title: label, canSave: true, onDonePress: onDonePress, onCancelPress: onCancelPress, canSaveActive: barCode, doneButtonText: "Add" }),
        react_1.default.createElement(core_1.Box, { className: classes.barCodeRootContainer },
            react_1.default.createElement(OptionSelector, { scanOption: scanOption, setScanOption: setScanOption }),
            scanOption === BarcodeEntryType.DEVICE_CAMERA && camera === CameraOptions.SYSTEM_CAMERA && (react_1.default.createElement(ScanWithCamera, { setScanOption: setScanOption, setValidBarCode: setBarCode, camera: camera, setCamera: setCamera, validator: validator })),
            scanOption === BarcodeEntryType.HANDHELD_SCANNER && (react_1.default.createElement(ScanWithHandheldCamera, { value: value, placeholder: placeholder, setValidBarCode: setBarCode, validator: validator })),
            scanOption === BarcodeEntryType.MANNUAL_ENTRY && (react_1.default.createElement(EnterManually, { value: value, setValidBarCode: setBarCode, placeholder: placeholder, readOnly: !!readOnly })))));
};
const usebarcodeStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    root: (props) => (Object.assign(Object.assign({ width: '100%', height: '100%' }, (props.isCameraActive && {})), { [theme.breakpoints.down(utils_1.MOBILE_BREAKPOINT)]: Object.assign(Object.assign({}, (props.isCameraActive && {})), (!props.isCameraActive && {
            height: '100%',
        })) })),
}));
const DefaultView = props => {
    const { readOnly } = props;
    const classes = CommonWeb_1.useStyles();
    const [tooltip, setTooltip] = react_1.useState(false);
    return (react_1.default.createElement("div", { onMouseEnter: () => readOnly && setTooltip(true), onMouseLeave: () => readOnly && setTooltip(false) },
        react_1.default.createElement(DialogWrapperWeb_1.default, Object.assign({}, props, { clearValue: () => props.onChange(''), type: 'barcode', position: 'bottom', renderHeader: () => {
                return (react_1.default.createElement(core_1.InputLabel, { error: props.error, shrink: !!props.value, className: clsx_1.default(!!props.value && classes.labelShrink) }, react_1.default.createElement(TGLabelWrapperWeb_1.default, { required: props.required, readOnly: readOnly, label: props.label, info: props.info, tooltip: tooltip, error: props.error })));
            }, renderMiddleValue: () => {
                return react_1.default.createElement(react_1.default.Fragment, null, props.value && react_1.default.createElement("div", { className: classes.uploadList }, props.value));
            }, renderValue: () => {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.FormHelperText, { error: props.error, className: clsx_1.default(props.warning && classes.warningText) }, props.helperText)));
            }, renderComponent: toggleModal => {
                return react_1.default.createElement(TGBarCodeFields, Object.assign({}, props, { toggleModal: toggleModal }));
            } }))));
};
exports.default = DefaultView;
//# sourceMappingURL=TGBarCodeFieldWeb.js.map